import React from "react";
import { Link } from "react-router-dom";
import { Sparkles, ArrowUpRight } from "lucide-react";
import { Tile } from "./primitives";

export default function SocialManagerCard() {
  return (
    <Tile title="Social Manager" testid="tile-social">
      <Link
        to="/admin/social"
        data-testid="social-manager-link"
        className="flex items-center gap-3 group"
      >
        <div className="h-10 w-10 rounded-full bg-[#E8F0EB] text-[#2B5339] flex items-center justify-center">
          <Sparkles size={16} />
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-sm font-medium text-[#1C2B23] group-hover:text-[#2B5339]">
            Spin content → push to Buffer
          </div>
          <div className="text-xs text-[#5C6B62] mt-0.5">
            LinkedIn · Pinterest · Shorts scripts
          </div>
        </div>
        <ArrowUpRight
          size={14}
          className="text-[#5C6B62] group-hover:text-[#2B5339]"
        />
      </Link>
    </Tile>
  );
}
